var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"secure"}},[(_vm.$route.path === '/login')?_c('Login'):_vm._e(),(_vm.$route.path !== '/login')?_c('navbar',{attrs:{"publicSection":true},on:{"logout":_vm.logout}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }